import { useCallback, useEffect, useState } from "react";

import { requestUsers, requestUsersWork } from "services/api/api";
import useQueryString from "services/query/useQueryString";

import RectanglesChart from "./charts/RectanglesChart";
import Options from "./ui/Options";
import Spinner from "./ui/spinner/Spinner";

function App() {
  const [accessToken] = useQueryString("access_token");
  const [lang] = useQueryString("lang", "ru");
  const [role] = useQueryString("role", null);

  const [loading, setLoading] = useState(true);
  const [data, updateData] = useState({
    users: [],
    work: {},
    from: null,
    to: null,
    showByActionType: null,
    showByTimeInterval: null,
    removeTenMinIntervals: false,
    removeTwentyMinIntervals: false,
  });

  const [i18n, updateI18n] = useState(null);

  const translate = useCallback(
    (id, params, template = "{{param}}") => {
      let translation = i18n && i18n[id] ? i18n[id] : id;

      if (translation && translation.replace && params) {
        for (let paramId in params) {
          translation = translation.replace(
            template.replace("param", paramId),
            params[paramId]
          );
        }
      }

      return translation;
    },
    [i18n]
  );

  useEffect(() => {
    fetch(`/i18n/${["ru", "en"].indexOf(lang) > -1 ? lang : "ru"}.json`)
      .then((response) => response.json())
      .then((i18n) => updateI18n(i18n))
      .catch((error) => console.log("error", error));
  }, [lang]);

  useEffect(() => {
    requestUsers(accessToken, { role }).then((users = []) =>
      updateData((currentData) => ({ ...currentData, users }))
    );
  }, [accessToken, role]);

  useEffect(() => {
    if (data.users.length > 0 && data.from && data.to) {
      setLoading(true);

      requestUsersWork(accessToken, {
        from: new Date(data.from).toISOString(),
        till: new Date(data.to).toISOString(),
        action_type:
          data.showByActionType === "all" ? null : data.showByActionType,
        group_by: data.showByTimeInterval,
        role,
      }).then((data = []) => {
        const work = {};

        data.forEach((workData) => {
          const { uuid } = workData;

          if (!work[uuid]) {
            work[uuid] = [];
          }

          work[uuid].push(workData);
        });

        updateData((currentData) => ({ ...currentData, work }));

        setLoading(false);
      });
    }
  }, [
    data.users.length,
    data.from,
    data.to,
    data.showByActionType,
    data.showByTimeInterval,
    accessToken,
    role,
  ]);

  return (
    <div>
      <main>
        {!i18n ? (
          <Spinner />
        ) : (
          <>
            <Options
              lang={lang}
              updateData={updateData}
              translate={translate}
            />
            <RectanglesChart
              loading={loading}
              lang={lang}
              data={data}
              translate={translate}
            />
          </>
        )}
      </main>
    </div>
  );
}

export default App;
